import ContactLensSKU from '@/models/item/sku/contact-lens'
import { UsualPower } from '@/services/api/usual-power/usual-power'
import { Either } from 'fp-ts/lib/Either'

interface InitSkuStrategy {
  execute(ctx: InitSkuStrategyContext): InitSkuResult
}

interface InitSkuResult {
  selectedLeftSku: ContactLensSKU | null,
  selectedRightSku: ContactLensSKU | null,
}

interface InitSkuStrategyContext {
  skus: ContactLensSKU[]
}

const emptyInitResult: InitSkuResult = {
  selectedLeftSku: null,
  selectedRightSku: null,
}

class UsualPowerInitSkuStrategy implements InitSkuStrategy {
  constructor(
    private readonly usualPowerResult: Either<Error, UsualPower>
  ) {}

  execute(ctx: InitSkuStrategyContext): InitSkuResult {
    return this.usualPowerResult.fold(
      (error) => {
        throw error
      },
      (usualPower) => {
        const userSettingsLeftPower = usualPower.leftPathname
        const userSettingsRightPower = usualPower.rightPathname

        return {
          selectedLeftSku: ctx.skus.find((sku) => {
            if (sku.powerTag && userSettingsLeftPower) return sku.powerTag.pathname === userSettingsLeftPower

            return false
          }) || null,
          selectedRightSku: ctx.skus.find((sku) => {
            if (sku.powerTag && userSettingsRightPower) return sku.powerTag.pathname === userSettingsRightPower

            return false
          }) || null,
        }
      }
    )
  }
}

class HeadInitSkuStrategy implements InitSkuStrategy {
  execute(ctx: InitSkuStrategyContext): InitSkuResult {
    return {
      selectedLeftSku: ctx.skus.length > 0 ? ctx.skus[0] : null,
      selectedRightSku : ctx.skus.length > 0 ? ctx.skus[0] : null,
    }
  }
}

class CompoundInitSkuStrategy {
  constructor(readonly strategies: InitSkuStrategy[]) {}

  execute(ctx: InitSkuStrategyContext): InitSkuResult {
    return this.strategies.reduce(
      (previousResult: InitSkuResult, strategy) => {
        const {
          selectedLeftSku: previousLeft,
          selectedRightSku: previousRight,
        } = previousResult

        const {
          selectedLeftSku: currentLeft,
          selectedRightSku: currentRight,
        } = strategy.execute(ctx)

        return {
          selectedLeftSku: previousLeft ? previousLeft : currentLeft,
          selectedRightSku: previousRight ? previousRight : currentRight,
        }
      },
      emptyInitResult
    )
  }
}

const createDefaultInitSkuStrategy = (eitherUsualPower: Either<Error, UsualPower>) => new CompoundInitSkuStrategy([
  new UsualPowerInitSkuStrategy(eitherUsualPower),
  new HeadInitSkuStrategy(),
])

export {
  UsualPowerInitSkuStrategy,
  HeadInitSkuStrategy,
  CompoundInitSkuStrategy,
  createDefaultInitSkuStrategy,
}
